var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGeneratorDeschisInaltaTensiune(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 83,
    viewBox: "0 0 76 83",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 38.5,
    cy: 41.5,
    r: 25.5,
    stroke: "black",
    strokeWidth: 4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.358 36.1989C45.1212 35.4318 44.7945 34.7453 44.3778 34.1392C43.9706 33.5237 43.4782 32.9981 42.9006 32.5625C42.3324 32.1269 41.679 31.8002 40.9403 31.5824C40.2017 31.3551 39.3968 31.2415 38.5256 31.2415C36.9631 31.2415 35.571 31.6345 34.3494 32.4205C33.1278 33.2064 32.1667 34.3617 31.4659 35.8864C30.7746 37.4015 30.429 39.2481 30.429 41.4261C30.429 43.6231 30.7746 45.4839 31.4659 47.0085C32.1572 48.5331 33.1184 49.6932 34.3494 50.4886C35.5805 51.2746 37.0104 51.6676 38.6392 51.6676C40.1165 51.6676 41.3949 51.3835 42.4744 50.8153C43.5634 50.2472 44.4015 49.4422 44.9886 48.4006C45.5758 47.3494 45.8693 46.1184 45.8693 44.7074L47.0625 44.892H39.1648V40.7727H50.9688V44.267C50.9688 46.7576 50.4384 48.9119 49.3778 50.7301C48.3172 52.5483 46.8589 53.9498 45.0028 54.9347C43.1468 55.91 41.0161 56.3977 38.6108 56.3977C35.9309 56.3977 33.5777 55.7964 31.5511 54.5938C29.5341 53.3816 27.9574 51.6629 26.821 49.4375C25.6941 47.2027 25.1307 44.5511 25.1307 41.483C25.1307 39.1345 25.4621 37.0369 26.125 35.1903C26.7973 33.3438 27.7348 31.7765 28.9375 30.4886C30.1402 29.1913 31.5511 28.2064 33.1705 27.5341C34.7898 26.8523 36.5511 26.5114 38.4545 26.5114C40.0644 26.5114 41.5653 26.7481 42.9574 27.2216C44.3494 27.6856 45.5852 28.3485 46.6648 29.2102C47.7538 30.072 48.6487 31.0947 49.3494 32.2784C50.0502 33.4621 50.5095 34.7689 50.7273 36.1989H45.358Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38 14L38 4.01866e-07",
    stroke: "black",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeneratorDeschisInaltaTensiune);
export default __webpack_public_path__ + "static/media/generator_deschis_inalta_tensiune.b8e70c8da456e4623a510fad3763cbdd.svg";
export { ForwardRef as ReactComponent };